import React from 'react';
import './services.css';

function ServicesList() {
  return (
    <>
        <ol className='serviciosIndex'>
            <li><h4><span>Pensamos</span></h4><div className='data'><p>Cada proyecto es único. Diseñamos estrategias a medida para alcanzar tus objetivos comerciales.</p></div></li>
            <li><h4><span>Creamos</span></h4><div className='data'><p><span>Branding</span></p><p><span>Web Design</span></p><p><span>UX - UI</span></p></div></li>
            <li><h4><span>Desarrollamos</span></h4><div className='data'><p><span>Ecommerce</span></p><p><span>Apps</span></p><p><span>PWA</span></p><p><span>Web Development</span></p><p><span>WebSites</span></p></div></li>
            <li><h4><span>Lanzamos</span></h4><div className='data'><p><span>SEO - SEM</span></p><p><span>Analytics & Keywords Strategy</span></p></div></li>
        </ol>
    </>
  );
}
export default ServicesList;